/* ═══════════════════════════════════════
   KAHPLE THEME JS v3.0
═══════════════════════════════════════ */
(function(){
'use strict';

// ── CUSTOM CURSOR ──
(function(){
  var cur = document.getElementById('cur');
  if(!cur || !window.matchMedia('(pointer:fine)').matches) return;
  var cd = cur.querySelector('.c-d');
  var cr = cur.querySelector('.c-r');
  var cmx=0, cmy=0, rx=0, ry=0;
  window.addEventListener('mousemove', function(e){
    cmx = e.clientX; cmy = e.clientY;
    if(cd){ cd.style.left = cmx+'px'; cd.style.top = cmy+'px'; }
  });
  (function raf(){
    rx += (cmx-rx)*.1; ry += (cmy-ry)*.1;
    if(cr){ cr.style.left = rx+'px'; cr.style.top = ry+'px'; }
    requestAnimationFrame(raf);
  })();
  function addHover(el){
    el.addEventListener('mouseenter', function(){ document.body.classList.add('hov'); });
    el.addEventListener('mouseleave', function(){ document.body.classList.remove('hov'); });
  }
  document.querySelectorAll('a, button, .btn, .btn-plan, .incl-card, .plan, .pq-item, .proc-step, .constat-card, .testi-card, .sm-step, .product-card, .activite-card, .fq-q, .variant-btn').forEach(addHover);
})();

/* ── SCROLL PROGRESS ── */
var sp=document.getElementById('sp');
if(sp)addEventListener('scroll',function(){
  sp.style.width=(scrollY/(document.documentElement.scrollHeight-innerHeight)*100)+'%';
},{passive:true});

/* ── HEADER ── */
var hdr=document.querySelector('.hdr');
if(hdr)addEventListener('scroll',function(){hdr.classList.toggle('s',scrollY>60);},{passive:true});

/* ── MOBILE MENU ── */
var burger=document.querySelector('.hdr-burger');
var mobileNav=document.querySelector('.hdr-mobile-nav');
var closeBtn=document.querySelector('.hdr-close');
if(burger&&mobileNav){
  burger.addEventListener('click',function(){mobileNav.classList.add('open');document.body.style.overflow='hidden';});
  if(closeBtn)closeBtn.addEventListener('click',function(){mobileNav.classList.remove('open');document.body.style.overflow='';});
  mobileNav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mobileNav.classList.remove('open');document.body.style.overflow='';});});
}

/* ── REVEALS ── */
if('IntersectionObserver'in window){
  var ro=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');ro.unobserve(x.target);}});},{threshold:.07});
  document.querySelectorAll('.r').forEach(function(el){ro.observe(el);});
}else{document.querySelectorAll('.r').forEach(function(el){el.classList.add('in');});}

/* ── TEXT SCRAMBLE on eyebrows ── */
var sc='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789·—';
function scramble(el){
  if(el.dataset.sc)return;el.dataset.sc='1';
  var orig=el.textContent,it=0,max=orig.length*2;
  var iv=setInterval(function(){
    el.textContent=orig.split('').map(function(c,i){
      if(c===' ')return ' ';if(i<it/2)return orig[i];
      return sc[Math.floor(Math.random()*sc.length)];
    }).join('');
    it++;if(it>max){el.textContent=orig;clearInterval(iv);}
  },32);
}
var so=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting){scramble(x.target);so.unobserve(x.target);}});},{threshold:.5});
document.querySelectorAll('.eyebrow').forEach(function(el){so.observe(el);});

/* ── HERO HEADLINE REVEAL ── */
setTimeout(function(){var h=document.querySelector('.hero-h1');if(h)h.classList.add('go');},80);

/* ── FAQ ── */
document.querySelectorAll('.fq-q').forEach(function(btn){
  btn.addEventListener('click',function(){
    var it=btn.closest('.fq'),open=it.classList.contains('open');
    document.querySelectorAll('.fq').forEach(function(x){x.classList.remove('open');x.querySelector('.fq-q').setAttribute('aria-expanded','false');});
    if(!open){it.classList.add('open');btn.setAttribute('aria-expanded','true');}
  });
});

/* ── DRAG SCROLL ── */
var trk=document.getElementById('drag');
if(trk){
  var isD=false,sx,sl;
  trk.addEventListener('mousedown',function(e){isD=true;sx=e.pageX-trk.offsetLeft;sl=trk.scrollLeft;});
  trk.addEventListener('mouseleave',function(){isD=false;});
  trk.addEventListener('mouseup',function(){isD=false;});
  trk.addEventListener('mousemove',function(e){if(!isD)return;e.preventDefault();trk.scrollLeft=sl-(e.pageX-trk.offsetLeft-sx)*1.15;});
  trk.addEventListener('touchstart',function(e){sx=e.touches[0].pageX;sl=trk.scrollLeft;},{passive:true});
  trk.addEventListener('touchmove',function(e){trk.scrollLeft=sl+(sx-e.touches[0].pageX)*1.1;},{passive:true});
}

/* ── MAGNETIC BUTTONS ── */
document.querySelectorAll('.btn-gold').forEach(function(el){
  el.addEventListener('mousemove',function(e){
    var r=el.getBoundingClientRect();
    el.style.transform='translate('+(e.clientX-r.left-r.width/2)*.08+'px,'+(e.clientY-r.top-r.height/2)*.08+'px)';
  });
  el.addEventListener('mouseleave',function(){el.style.transform='';});
});

/* ── POUR QUI panel ── */
var sectors=[
  {label:'🍽 Restauration & Foodservice',desc:'Votre planning contient 30 idées de posts prêtes à publier — plats du jour, coulisses, promotions, avis clients — tout rédigé pour votre secteur.',tags:['Plats du jour','Coulisses','Promotions','Avis clients'],url:'/products/planning-restauration',cta:'Voir le planning Restauration →',price:'19 €',period:'/mois · sans engagement'},
  {label:'✂️ Coiffure & Beauté',desc:'Avant/après, conseils beauté, témoignages, promotions — 30 posts calibrés pour attirer de nouveaux clients dans votre salon.',tags:['Avant/après','Conseils beauté','Résultats','Promotions'],url:'/products/planning-coiffure-beaute',cta:'Voir le planning Coiffure & Beauté →',price:'19 €',period:'/mois · sans engagement'},
  {label:'🛍 Boutiques & Commerce',desc:'Nouveautés produits, ambiance boutique, promotions flash, avis clients — tout pour animer votre compte et faire revenir vos clients.',tags:['Nouveautés','Promotions','Ambiance boutique','Avis clients'],url:'/products/planning-commerce-retail',cta:'Voir le planning Commerce →',price:'19 €',period:'/mois · sans engagement'},
  {label:'🥐 Artisans & Créateurs',desc:'Savoir-faire, coulisses de création, valeurs, storytelling — des posts qui valorisent votre métier et créent un lien fort avec votre audience.',tags:['Savoir-faire','Créations','Coulisses','Valeurs'],url:'/products/planning-artisanat',cta:'Voir le planning Artisanat →',price:'19 €',period:'/mois · sans engagement'},
  {label:'📅 Services & Prestations',desc:'Expertise, résultats, témoignages, conseils pratiques — un contenu qui établit votre crédibilité et convertit vos abonnés en clients.',tags:['Expertise','Résultats','Témoignages','Conseils'],url:'/products/planning-services-locaux',cta:'Voir le planning Services →',price:'19 €',period:'/mois · sans engagement'},
  {label:'💎 Autre activité',desc:"Votre activité ne rentre pas dans une case ? On crée un planning 100% personnalisé, adapté à votre ton, vos produits et votre identité de marque.",tags:['100% personnalisé','Votre ton','Vos produits','Votre identité'],url:'/products/planning-sur-mesure',cta:'Demander un planning sur-mesure →',price:'79 €',period:'paiement unique · sur-mesure'}
];
var pqGrid=document.getElementById('pq-grid');
var pqTc=document.getElementById('pq-tc');
function updSector(i){
  var s=sectors[i];if(!s||!pqTc)return;
  pqTc.classList.add('fade');
  setTimeout(function(){
    var ts=document.getElementById('pq-ts');var tq=document.getElementById('pq-tq');
    var tt=document.getElementById('pq-tt');var cta=document.getElementById('pq-cta');
    var priceEl=document.getElementById('pq-price');var periodEl=document.getElementById('pq-period');
    if(ts)ts.textContent=s.label;
    if(tq)tq.textContent=s.desc;
    if(tt)tt.innerHTML=s.tags.map(function(t){return '<span class="pq-tag">'+t+'</span>';}).join('');
    if(cta){cta.innerHTML='<span>'+s.cta+'</span>';cta.href=s.url;}
    if(priceEl)priceEl.textContent=s.price;
    if(periodEl)periodEl.textContent=s.period;
    pqTc.classList.remove('fade');
  },280);
  pqGrid&&pqGrid.querySelectorAll('.pq-card').forEach(function(c,j){c.classList.toggle('active',j===i);});
}
pqGrid&&pqGrid.querySelectorAll('.pq-card').forEach(function(card,i){
  card.addEventListener('mouseenter',function(){updSector(i);});
  card.addEventListener('focus',function(){updSector(i);});
});

/* ── VARIANT SELECTOR ── */
document.querySelectorAll('[data-variant-selector] button').forEach(function(btn){
  btn.addEventListener('click',function(){
    document.querySelectorAll('[data-variant-selector] button').forEach(function(b){
      b.classList.remove('active');b.style.background='transparent';b.style.borderColor='var(--line2)';
    });
    btn.classList.add('active');btn.style.background='rgba(200,169,110,.1)';btn.style.borderColor='var(--gold)';
    var varId=btn.dataset.variantId;
    var cartInput=document.getElementById('variant-id-input');
    if(cartInput&&varId){cartInput.value=varId;}
    var priceEl=document.getElementById('selected-price');
    if(priceEl&&btn.dataset.price)priceEl.textContent=btn.dataset.price;
  });
});

/* ── CANVAS PARTICLES ── */
var cvs=document.getElementById('cvs');
if(cvs){
  var ctx=cvs.getContext('2d');
  var pts=[],W,H,mx=0,my=0;
  function resize(){W=cvs.width=innerWidth;H=cvs.height=innerHeight;}
  resize();
  addEventListener('resize',resize,{passive:true});
  addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;},{passive:true});
  for(var i=0;i<55;i++)pts.push({x:Math.random()*innerWidth,y:Math.random()*innerHeight,vx:(Math.random()-.5)*.3,vy:(Math.random()-.5)*.3,r:Math.random()*1.5+.5,a:Math.random()});
  function draw(){
    ctx.clearRect(0,0,W,H);
    pts.forEach(function(p){
      p.x+=p.vx;p.y+=p.vy;
      if(p.x<0||p.x>W)p.vx*=-1;if(p.y<0||p.y>H)p.vy*=-1;
      var dx=p.x-mx,dy=p.y-my,dist=Math.sqrt(dx*dx+dy*dy);
      if(dist<120){p.x+=dx/dist*1.2;p.y+=dy/dist*1.2;}
      ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
      ctx.fillStyle='rgba(200,169,110,'+p.a*.6+')';ctx.fill();
    });
    for(var a=0;a<pts.length;a++)for(var b=a+1;b<pts.length;b++){
      var dx=pts[a].x-pts[b].x,dy=pts[a].y-pts[b].y,dist=Math.sqrt(dx*dx+dy*dy);
      if(dist<100){ctx.beginPath();ctx.moveTo(pts[a].x,pts[a].y);ctx.lineTo(pts[b].x,pts[b].y);ctx.strokeStyle='rgba(200,169,110,'+(1-dist/100)*.08+')';ctx.lineWidth=.5;ctx.stroke();}
    }
    requestAnimationFrame(draw);
  }
  draw();
}

})();
